var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    opacity: 0.4,
    x: 0.5,
    fill: "url(#pattern0_4129_88806)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51273 33.75C3.06365 36.4417 6.50307 37.3665 9.19481 35.8156C9.19665 35.8146 9.19841 35.8135 9.20026 35.8124L10.0346 35.3305C11.6096 36.6781 13.42 37.7231 15.3746 38.413V39.375C15.3746 42.4816 17.893 45 20.9996 45C24.1062 45 26.6246 42.4816 26.6246 39.375V38.4131C28.5794 37.722 30.3899 36.6758 31.9645 35.3268L32.8027 35.8106C35.495 37.3639 38.9369 36.4405 40.4902 33.7481C42.0435 31.0557 41.1201 27.6138 38.4277 26.0605L37.5952 25.5806C37.9699 23.5414 37.9699 21.451 37.5952 19.4118L38.4277 18.9318C41.12 17.3785 42.0435 13.9367 40.4902 11.2443C38.9369 8.55193 35.4951 7.62847 32.8027 9.18176L31.9683 9.66366C30.3917 8.31779 28.5801 7.27471 26.6246 6.58687V5.625C26.6246 2.51842 24.1062 0 20.9996 0C17.893 0 15.3746 2.51842 15.3746 5.625V6.58687C13.4197 7.27796 11.6093 8.32421 10.0346 9.67315L9.19648 9.18756C6.50404 7.63418 3.06224 8.55765 1.50895 11.25C-0.0443428 13.9424 0.879036 17.3842 3.57148 18.9375L4.40398 19.4175C4.02921 21.4566 4.02921 23.547 4.40398 25.5863L3.57148 26.0662C0.886507 27.6237 -0.0338839 31.0588 1.51273 33.75ZM20.9996 15C25.1417 15 28.4995 18.3579 28.4995 22.5C28.4995 26.6421 25.1417 30 20.9996 30C16.8575 30 13.4996 26.6421 13.4996 22.5C13.4996 18.3579 16.8575 15 20.9996 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.d8d8e74631d1c0ae435e1c0520eb3a4e.svg";
export { ForwardRef as ReactComponent };